"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("@common/configuration");
const typing_1 = require("@common/typing");
const units_service_1 = require("./units.service");
class UnitMediaService extends units_service_1.UnitsService {
    constructor(token) {
        super(token);
        this.endpointBaseUrlV2 = configuration_1.Configuration.unitsServiceConfig().apiV2;
    }
    async getUnitMedia(uuid) {
        const response = await this.httpService.get(`${this.endpointBaseUrlV2}/unit-media?filter[unit_id]=${uuid}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async updateUnitMedia(unitMedia, uuid, user) {
        const provider = unitMedia instanceof typing_1.InsideMaps ? configuration_1.Configuration.PROVIDER_NAME.INSIDEMAPS : configuration_1.Configuration.PROVIDER_NAME.MATTERPORT;
        const data = {
            data: {
                type: "unit-media",
                attributes: {
                    unit_id: uuid,
                    media_provider: { name: provider },
                    code: unitMedia.code || "",
                    active: unitMedia.active,
                    done_by: user,
                },
            },
        };
        const response = await this.httpService.patch(`${this.endpointBaseUrlV2}/unit-media/${unitMedia.id}`, data, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async createUnitMedia(unitMedia, uuid, user) {
        const provider = unitMedia instanceof typing_1.InsideMaps ? configuration_1.Configuration.PROVIDER_NAME.INSIDEMAPS : configuration_1.Configuration.PROVIDER_NAME.MATTERPORT;
        const data = {
            data: {
                type: "unit-media",
                attributes: {
                    unit_id: uuid,
                    media_provider: { name: provider },
                    code: unitMedia.code || "",
                    active: unitMedia.active || false,
                    done_by: user,
                },
            },
        };
        const response = await this.httpService.post(`${this.endpointBaseUrlV2}/unit-media`, data, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
}
exports.UnitMediaService = UnitMediaService;
//# sourceMappingURL=unit-media.service.js.map